export default __webpack_public_path__ + "static/media/github.5f1fbedf.svg";